import {
  textFormatter,
  priorityFormatter,
  uppercaseTextFormatter,
  customDateFormatWithTime,
} from "components/Common/formatter";
import { Tooltip } from "antd";
import CustomLink from "components/Common/buttons/CustomLink";
import React from "react";
import { CANCEL_STATUSES, notAllowedTypes, taskSourceFormatter } from "pages/operations/tasks/variables";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import arrow from "assets/images/svg/arrow-white.svg";
import convertIcon from "assets/images/svg/convert.svg";
import cancelIcon from "assets/images/svg/remove-customers.svg";
import { USER_ROLES } from "utils/constants";
import { userHasOneOfRoles } from "utils/helpers/functions";

const color = "#444444";
export const taskColumns = (classes, hideRoles, onDelete) => [
  {
    title: "Task Type",
    dataIndex: "",
    key: "category",
    sort: true,
    render: row => (
      <Tooltip placement="bottom" title={`${row.category} task details`} color={color}>
        <div>
          <CustomLink to={`/operations/task/${row.id}`}>{uppercaseTextFormatter(row.category)}</CustomLink>
        </div>
      </Tooltip>
    ),
    width: "20%",
  },
  {
    dataIndex: "customerId",
    key: "customerId",
    title: "Customer ID",
    render: (_, task) =>
      task?.customer?.id ? (
        <CustomLink underlined target="_blank" to={`/customers/customer/${task?.customer?.id}`}>
          {task?.customer?.id}
        </CustomLink>
      ) : (
        textFormatter(task?.customer?.id)
      ),
    width: "20%",
  },
  {
    dataIndex: "customerName",
    key: "customerName",
    title: "Customer Name",
    render: (_, task) => priorityFormatter(task?.customer?.name),
    width: "16%",
  },
  {
    title: "Depot",
    dataIndex: "depot",
    key: "depot",
    sort: true,
    render: (cellContent, task) => textFormatter(task.depot),
    width: "20%",
  },
  {
    dataIndex: "assignedTo",
    key: "assignedTo",
    title: "ASSIGNED TO",
    render: (cellContent, task) => (
      <CustomLink underlined target="_blank" to={`/user/${task.assignedTo}`}>
        {textFormatter(task.assignedTo)}
      </CustomLink>
    ),
    width: "40%",
  },
  {
    dataIndex: "source",
    key: "source",
    title: "Task Source",
    render: (cellContent, task) => taskSourceFormatter(task),
  },
  {
    dataIndex: "priority",
    key: "priority",
    title: "Priority",
    render: cellContent => (
      <div className={classes.overflowText} title={cellContent}>
        {cellContent}
      </div>
    ),
  },
  {
    title: "Task Status",
    dataIndex: "status",
    key: "status",
    sort: true,
    render: (cellContent, task) => textFormatter(task.status),
    width: "20%",
  },
  {
    title: "Date Created",
    dataIndex: "createdAt",
    key: "createdAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
  {
    title: "Last Updated Date",
    dataIndex: "updatedAt",
    key: "updatedAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },

  ...(!userHasOneOfRoles(hideRoles)
    ? [
        {
          title: "",
          width: "4%",
          key: "action",
          render: (cellContent, task) => (
            <NGIDropdownButton
              position="left"
              toggleEl={<ButtonGroup icon={arrow} />}
              menuItems={[
                ...(!notAllowedTypes.includes(task.category) && task.status === CANCEL_STATUSES.ASSIGNED
                  ? [
                      {
                        label: "Convert Task",
                        icon: convertIcon,
                        callback: () => onDelete(task, true),
                      },
                    ]
                  : []),
                ...(task.status === CANCEL_STATUSES.INCOMPLETABLE || task.status === CANCEL_STATUSES.ASSIGNED
                  ? [
                      {
                        label: "Cancel Task",
                        icon: cancelIcon,
                        callback: () => onDelete(task),
                        roles: [
                          USER_ROLES.SYSTEM_FULL_ADMINS,
                          USER_ROLES.IT_OPERATIONS,
                          USER_ROLES.IT_OPERATIONS_LEADERSHIP,
                          task.category === "Repossession" && USER_ROLES.OPERATION_MANAGERS,
                        ],
                      },
                    ]
                  : []),
              ]}
            />
          ),
        },
      ]
    : []),
];
